import { TemplateApiUrls } from "@/modules/template/common/enum";
import type {
  ICreateCurrencyExchangeTemplateRequest,
  ICurrencyExchangeTemplate,
  IUpdateCurrencyExchangeTemplateRequest,
} from "@/modules/template/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const currencyExchangeTemplateApi = createApi({
  reducerPath: "currencyExchangeTemplateApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getCurrencyExchangeTemplate: builder.query<ICurrencyExchangeTemplate, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TemplateApiUrls.CurrencyExchangeTemplateV2}/${id}`,
      }),
      keepUnusedDataFor: 0,
    }),
    createCurrencyExchangeTemplate: builder.mutation<string, ICreateCurrencyExchangeTemplateRequest>(
      withIdempotency<ICreateCurrencyExchangeTemplateRequest>(
        TemplateApiUrls.CurrencyExchangeTemplateV2
      )),
    updateCurrencyExchangeTemplate: builder.mutation<string, IUpdateCurrencyExchangeTemplateRequest>(
      {
        query: ({ data, id }) => ({
          url: `${TemplateApiUrls.CurrencyExchangeTemplateV2}/${id}`,
          method: "PUT",
          data,
        }),
      }),
  }),
});

export const {
  useGetCurrencyExchangeTemplateQuery,
  useCreateCurrencyExchangeTemplateMutation,
  useUpdateCurrencyExchangeTemplateMutation,
} = currencyExchangeTemplateApi;
